import React from 'react'

export const MenuData = [
  { title: 'About', 
    link: "/about"},

  { title: 'Homes', 
    link: "/homes"},

  { title: 'Rentals', 
    link: "/rentals"}
]